module.exports = new __parcel__URL__("warningInfoIcon.4e11f8c0.svg").toString();